<div class="row g-1 q-card-list">
    <ng-container *ngIf="hasSubCollections">
        <div class="col-12 p-0 m-0 qatch uikit-products-list"
            *ngFor="let subCategory of subCategories; let colIndex = index">
            <div class="sub-category-header mx-auto text-center">
                <h4 class="qatch ps-2 pt-2 font-bold">{{subCategory.name}}</h4>
                <h5 class="qatch ps-2 p-2" [innerText]="subCategory.description"></h5>
            </div>
            <div class="row p-0 m-0">
                <div class="col p-0 m-0 qatch uikit-products-list"
                    *ngFor="let columnProducts of subCategory.products; let colIndex = index">
                    <ng-container *ngFor="let product of columnProducts; let isFirst = first; let rowIndex = index">
                        <div class="vp-1 qatch" *ngIf="!product.hasImageLoadingError">
                            <uikit-product [productMeta]="productMeta" [loading]="loading" [data]="product"
                                [index]="isFirst ? colIndex : 10" [maxShowIndex]="3"
                                (updateReaction)="onUpdateReaction($event, colIndex, rowIndex)"
                                [lovedCount]="product.loved_count" [isCollectionPage]="isCollectionPage"
                                (onError)="product.hasImageLoadingError = true;" (onClick)="onProductClick($event)">
                            </uikit-product>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="sub-category-footer mx-auto text-center" *ngIf="subCategory.totalProducts > 8">
                <a class="btn btn-link text-danger m-0 font-bold" (click)="loadMore(subCategory)">View More</a>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!hasSubCollections">
        <div class="col p-0 m-0 qatch uikit-products-list"
            *ngFor="let columnProducts of products; let colIndex = index">
            <ng-container *ngFor="let product of columnProducts; let isFirst = first; let rowIndex = index">
                <div class="vp-1 qatch" *ngIf="!product.hasImageLoadingError">
                    <uikit-product [productMeta]="productMeta" [loading]="loading" [data]="product"
                        [index]="isFirst ? colIndex : 10" [maxShowIndex]="3"
                        (updateReaction)="onUpdateReaction($event, colIndex, rowIndex)"
                        [lovedCount]="product.loved_count" [isCollectionPage]="isCollectionPage"
                        (onError)="product.hasImageLoadingError = true;" (onClick)="onProductClick($event)">
                    </uikit-product>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <div *ngIf="!rawData?.length && !ploading && !hasSubCollections" class="no-record-message">
        <span>{{displayEmptyMessage}}</span>
    </div>
</div>

<app-loader [visible]="ploading" class="vmt-5" [text]="loadingText"></app-loader>

<button class="btn btn-zblack btn-just-icon position-fixed" *ngIf="hasScrolled" (click)="gotoTop();"
    style="bottom: 40px;right: 10px;z-index: 1;">
    <i class="bi bi-arrow-up"></i>
</button>